<template>
    <textarea ref="inputLong" class="saved-input-long" v-on="handlers" placeholder="ESCRIBIR"></textarea>
</template>
<style scoped>
.saved-input-long{
    outline: none;
    border:0;
    background-color: transparent;
    resize: none;
    text-align:left;
    overflow: hidden;
    text-overflow: clip;
    z-index: 10;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: grey;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: grey;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: grey;
}
</style>
<script>
    export default {
        props: ['number'],
        data() {
            const vm = this;
            return {
                dbId: "undefined",
                handlers: {
                  input: vm.handleInput,
                  textInput: vm.handleInput,
                  change: vm.handleInput,
                  keydown: vm.handleInput,
                  keyup: vm.handleInput,
                  focus: vm.handleInput,
                  paste: vm.handleInput
                }
            }
        },
        methods: {
            handleInput(){
                this.$refs.inputLong.scrollTop = 0.0;

                this.$db.inputs.put({
                    id: this.dbId,
                    text: this.$refs.inputLong.value
                }).catch(function(error){
                    console.log("error uploading file" + error);
                });          
            },
            async loadInput(){
                var value = await this.$db.inputs.get({
                    id: this.dbId,
                }).catch(function(error){
                    console.log("error uploading file" + error);
                });
                if (value === undefined) return;
                console.log(value);
                this.$refs.inputLong.value = value.text; 
            }
        },
        mounted(){
            this.dbId = `${this.$route.params.type}-${this.$route.params.chapter}-${this.$route.params.number}-savedInputLong-${this.number}`;
            this.loadInput();
        }
    }
</script>
